import { ExitIntentAreas } from 'sections/onsite-campaigns/types';

export function parseExitIntentAreas(exitIntentAreas: ExitIntentAreas[]) {
  const intentAreas = [];

  exitIntentAreas &&
    exitIntentAreas.forEach(area => {
      switch (area) {
        case ExitIntentAreas.TopLeft:
          intentAreas.push('top-left');
          break;
        case ExitIntentAreas.TopRight:
          intentAreas.push('top-right');
          break;
        case ExitIntentAreas.LeftTop:
          intentAreas.push('left-top');
          break;
        case ExitIntentAreas.RightTop:
          intentAreas.push('right-top');
          break;
        case ExitIntentAreas.LeftBottom:
          intentAreas.push('left-bottom');
          break;
        case ExitIntentAreas.RightBottom:
          intentAreas.push('right-bottom');
          break;
        case ExitIntentAreas.BottomLeft:
          intentAreas.push('bottom-left');
          break;
        case ExitIntentAreas.BottomRight:
          intentAreas.push('bottom-right');
          break;
        default:
          break;
      }
    });
  return intentAreas;
}
